const state = {
    hotelRoutesObj: null,
    hotelSearchObj: null,
    lsAirports:null
};

const getters = {
    GET_HOTEL_ROUTES_OBJ: (state) => {
        return state.hotelRoutesObj;
    },
    GET_HOTEL_SEARCH_OBJ: (state) => {
        return state.hotelSearchObj;
    },

    GET_AIRPORTS_LIST:(state)=>{
        return state.lsAirports
    }
};


const actions = {

    CLEAR_HOTEL_SEARCH_STORE: ({ commit }) => {
        commit('clearHotelSearchStore');
    },
    SET_HOTEL_ROUTES_OBJ: ({ commit }, routes) => {

        commit('saveRoutesObj', routes);

    },
    SET_HOTEL_SEARCH_OBJ: ({ commit }, search) => {

        commit('savehotelSearchObj', search);

    },
    SET_AIRPORTS_LIST:({commit},value)=>{
        commit('saveAirports',value)
    }

};


const mutations = {
    clearHotelSearchStore: (state) => {
        state.hotelRoutesObj = null;
        state.hotelSearchObj = null;
       state.lsAirports=null
    },

    saveRoutesObj: (state, routes) => {
        state.hotelRoutesObj = routes;
    },
    savehotelSearchObj: (state, search) => {
        state.hotelSearchObj = search;
       
    },
    saveAirports:(state,val)=>{
        state.lsAirports=val
    }

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}